import client from '@/api/client';
import { BASE_URL } from '@/constants';
import { objectToQueryString } from '@/utils/sfaas_temp';

export default {
	async getCommCodes(codeType, plantCd) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${codeType}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getPqyTotSttsList({ searchParams, pagingInfo }) {
		let queryStr = '';
		queryStr = objectToQueryString({
			strDt: searchParams.strDt,
			endDt: searchParams.endDt,
			partClCd: searchParams.partClCd,
			currentPage: pagingInfo.currentPage,
			pageUnit: pagingInfo.pageUnit
		});
		try {
			const response = await client.get(`${BASE_URL}/pqy/pcku/pqyTotStts/v1/formInfo${queryStr}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	}
};
